import * as CONSTANTS from 'common/constants/analyst-dashboards';

const col = (id: string, label: string) => ({
  id,
  label,
  isSortable: true,
  align: 'left' as const,
  disablePadding: false,
});

export const columns = [
  col(CONSTANTS.COMPANY_NAME_KEY, CONSTANTS.COMPANY_NAME),
  col(CONSTANTS.STATUS_KEY, CONSTANTS.STATUS),
  col(CONSTANTS.NOTES_KEY, CONSTANTS.NOTES),
  col(CONSTANTS.OTHER_CONSULTANT_KEY, CONSTANTS.OTHER_CONSULTANT),
  col(CONSTANTS.ENGAGEMENT_MANAGER_KEY, CONSTANTS.ENGAGEMENT_MANAGER),
  col(CONSTANTS.VALUATION_DATE_KEY, CONSTANTS.VALUATION_DATE),
  col(CONSTANTS.CREATED_AT_KEY, CONSTANTS.CREATED_AT),
  col(CONSTANTS.VALUATION_FEE_KEY, CONSTANTS.VALUATION_FEE),
  col(CONSTANTS.DEAL_KEY, CONSTANTS.DEAL),
  col(CONSTANTS.DEAL_DUE_KEY, CONSTANTS.DEAL_DUE),
  col(CONSTANTS.DEAL_STAGE_KEY, CONSTANTS.DEAL_STAGE),
  col(CONSTANTS.NET_VALUE_KEY, CONSTANTS.NET_VALUE),
  col(CONSTANTS.SPLIT_KEY, CONSTANTS.SPLIT),
  col(CONSTANTS.PAYMENT_1_KEY, CONSTANTS.PAYMENT_1),
  col(CONSTANTS.PAY_1_DATE_KEY, CONSTANTS.PAY_1_DATE),
  col(CONSTANTS.PAYMENT_2_KEY, CONSTANTS.PAYMENT_2),
  col(CONSTANTS.PAY_2_DATE_KEY, CONSTANTS.PAY_2_DATE),
  col(CONSTANTS.PAYMENT_3_KEY, CONSTANTS.PAYMENT_3),
  col(CONSTANTS.PAY_3_DATE_KEY, CONSTANTS.PAY_3_DATE),
  col(CONSTANTS.REFUND_KEY, CONSTANTS.REFUND),
  col(CONSTANTS.REFUND_DATE_KEY, CONSTANTS.REFUND_DATE),
  col(CONSTANTS.ADJUSTMENT_KEY, CONSTANTS.ADJUSTMENT),
  col(CONSTANTS.ADJUSTMENT_DATE_KEY, CONSTANTS.ADJUSTMENT_DATE),
  col(CONSTANTS.BAD_DEBT_KEY, CONSTANTS.BAD_DEBT),
  col(CONSTANTS.BAD_DEBT_DATE_KEY, CONSTANTS.BAD_DEBT_DATE),
  col(CONSTANTS.RENEWAL_RATE_KEY, CONSTANTS.RENEWAL_RATE),
];
